import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import common_eng from "./assets/translations/eng.json";
import common_rus from "./assets/translations/rus.json";


i18n
    .use(XHR)
    .use(LanguageDetector)
    .init({
        debug: false,
        lng: 'ENG',
        resources: {
            'ENG': common_eng,
            'RUS': common_rus,
        },

        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }


    });
export default i18n;


// WEBPACK FOOTER //
// src/i18n.js